import { render } from "./WorkItem.vue?vue&type=template&id=65725edc"
import script from "./WorkItem.vue?vue&type=script&lang=js"
export * from "./WorkItem.vue?vue&type=script&lang=js"

import "./WorkItem.vue?vue&type=style&index=0&id=65725edc&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__